import type { PlayerProfileResponse, PlayerVisitsRes } from '@on3/api';
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb';
import { CompactPlayer } from 'components/Db/Profile/Header/CompactHeaderV2/CompactPlayerV2';
import { VisitCenter } from 'components/Db/Profile/VisitCenter';

import styles from './VisitCenterPage.module.scss';

interface VisitCenterPageProps {
  basicInfo: PlayerProfileResponse;
  visitCenter?: PlayerVisitsRes | null;
}

export const VisitCenterPage = ({
  visitCenter,
  basicInfo,
}: VisitCenterPageProps) => {
  return (
    <div className={styles.block}>
      <CompactPlayer className={styles.compactPlayer} />
      <BreadCrumb
        className={styles.breadcrumbs}
        crumbs={[
          { title: 'On3 DB', href: '/db/' },
          { title: `${basicInfo?.name}`, href: `/db/${basicInfo?.slug}/` },
        ]}
        title="Visit Center"
      />
      <section className={styles.visitCenter}>
        <h1>{`Visits for ${basicInfo?.name}`}</h1>
        <VisitCenter showAll visitCenter={visitCenter} />
      </section>
    </div>
  );
};
